<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { isMobile } from 'mobile-device-detect'
  import { mapActions, mapState } from 'vuex'
  import AttachmentItem from './AttachmentItem'

  export default {
    name: 'GroupFiles',
    components: {
      AttachmentItem,
    },
    props: {
      files: Array,
      canDelete: Boolean,
      topic: Boolean,
    },
    data() {
      return {
        isMobile: isMobile,
        maximumRecordsToShow: 8,
      }
    },
    computed: {
      ...mapState('auth', [ 'user' ]),
      showMore() {
        return this.maximumRecordsToShow < this.files.length
      },
    },
    created() {
      if (this.isMobile) {
        this.maximumRecordsToShow = 6
      }
    },
    methods: {
      ...mapActions('posts', ['deleteFile']),
      viewMore() {
        if (this.isMobile) {
          this.maximumRecordsToShow += 6
        } else {
          this.maximumRecordsToShow += 8
        }
      },
      async removeFile(file) {
        await this.deleteFile(file.id)
        this.$emit('onDeleteFile')
      },
    },
  }
</script>
